import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "qtl-tagname-popover" }
const _hoisted_4 = ["placeholder", "onKeydown"]
const _hoisted_5 = ["disabled", "aria-label"]

import { computed, nextTick, ref } from "vue";
import type { CellDataSimple, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { auxStore } from "@/store/auxillary";
import { i18n } from "@/i18n";
import { formatSimpleHtml } from "./cellFormat";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TagNameCellElementLite',
  props: {
    element: {},
    entityId: {}
  },
  emits: ["refreshNeeded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const t = (k: string) => i18n.global.t(k);
const aux = auxStore();

const renderedHtml = computed(() => formatSimpleHtml(props.element, t));

// Исходное имя берём из первого значения ячейки (имя тега - простое строковое поле).
const initialName = String((props.element.Data?.[0] as CellDataSimple)?.Value ?? "");
const tempName = ref<string>(initialName);

const menuOpen = ref(false);
const menuPos = ref<{ top: string; left: string }>({ top: "0px", left: "0px" });
const editBtnRef = ref<HTMLElement | null>(null);
const inputRef = ref<HTMLTextAreaElement | null>(null);

function openEditMenu(ev: MouseEvent) {
  // Поповер держим у нижнего правого угла кнопки
  const rect = editBtnRef.value?.getBoundingClientRect();
  if (rect) {
    menuPos.value = { top: `${rect.bottom + 2}px`, left: `${rect.right - 260}px` };
  } else {
    menuPos.value = { top: `${ev.clientY}px`, left: `${ev.clientX}px` };
  }
  // На открытии возвращаем актуальное имя и ставим фокус в поле.
  tempName.value = String((props.element.Data?.[0] as CellDataSimple)?.Value ?? "");
  menuOpen.value = true;
  nextTick(() => inputRef.value?.focus());
}

async function applyChanges() {
  if (!props.entityId || !tempName.value) return;
  const ok = (await aux.updateSingleTagName({
    Id: props.entityId,
    NewName: tempName.value,
  } as any)) as boolean;
  if (ok) {
    menuOpen.value = false;
    emit("refreshNeeded");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "qtl-tagname",
      innerHTML: renderedHtml.value
    }, null, 8, _hoisted_1),
    _createElementVNode("button", {
      ref_key: "editBtnRef",
      ref: editBtnRef,
      class: "qtl-tagname-edit-btn",
      type: "button",
      "aria-label": t('edit_label'),
      onClick: _withModifiers(openEditMenu, ["stop"])
    }, [
      _createVNode(_component_q_icon, {
        name: "edit",
        size: "16px"
      })
    ], 8, _hoisted_2),
    _createVNode(MostaContextMenu, {
      visible: menuOpen.value,
      position: menuPos.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (menuOpen.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "inputRef",
            ref: inputRef,
            class: "qtl-tagname-popover__input",
            rows: "1",
            placeholder: t('name'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempName).value = $event)),
            onKeydown: [
              _cache[1] || (_cache[1] = _withKeys(($event: any) => (menuOpen.value = false), ["esc"])),
              _withKeys(_withModifiers(applyChanges, ["prevent"]), ["enter"])
            ]
          }, null, 40, _hoisted_4), [
            [_vModelText, tempName.value]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "qtl-tagname-popover__apply",
            disabled: !tempName.value,
            "aria-label": t('apply_changes'),
            onClick: applyChanges
          }, [
            _createVNode(_component_q_icon, {
              name: "done",
              size: "18px"
            })
          ], 8, _hoisted_5)
        ])
      ]),
      _: 1
    }, 8, ["visible", "position"])
  ], 64))
}
}

})